interface IHotelPromotion {
  readonly type: string;
  readonly description: string;
}

const PROMOTION_DATA = {
  ADULTS_ONLY: {
    description: {
      es: 'Tarifa especial solo adultos',
      pt: 'Tarifa especial para adultos',
    },
    type: 'service',
  },

  BEST_AVAILABLE_RATE: {
    description: { es: '¡Mejor tarifa encontrada!', pt: 'Melhor tarifa encontrada' },
    type: 'rate',
  },

  BLACK_FRIDAY_OFFER: {
    description: { es: 'Oferta Black Friday', pt: 'Oferta Black Friday' },
    type: 'campaign',
  },

  EASTER_CAMPAIGN: {
    description: {
      es: 'Taria especial Semana Santa',
      pt: 'Tarifa especial Semana Santa',
    },
    type: 'campaign',
  },

  EASTER_CAMPAING: {
    description: {
      es: 'Taria especial Semana Santa',
      pt: 'Tarifa especial Semana Santa',
    },
    type: 'campaign',
  },

  EARLY_BOOKING: {
    description: { es: 'Oferta anticipada', pt: 'Oferta antecipada' },
    type: 'rate',
  },

  EXCLUSIVE_DEAL: {
    description: { es: 'Oferta exclusiva', pt: 'Oferta exclusiva' },
    type: 'rate',
  },

  NEW_YEAR_EARLY_BOOKING_CAMPAIGN: {
    description: { es: 'Oferta de Año Nuevo', pt: 'Oferta de Ano Novo' },
    type: 'campaign',
  },
  NEW_YEAR_EARLY_BOOKING_CAMPAING: {
    description: { es: 'Oferta de Año Nuevo', pt: 'Oferta de Ano Novo' },
    type: 'campaign',
  },

  LAST_MINUTE: {
    description: { es: 'Oferta de último minuto', pt: 'Oferta de último minuto' },
    type: 'rate',
  },

  LONG_STAY_DISCOUNT: {
    description: { es: 'Oferta de larga estadia', pt: 'Oferta de estadia prolongada' },
    type: 'rate',
  },

  MINIMUM_STAY: {
    description: {
      es: 'Tarifa especial minimo de estadía',
      pt: 'Tarifa especial de estadia mínima',
    },
    type: 'rate',
  },

  FREE_NIGTHS: {
    description: { es: '¡Noches gratis!', pt: 'Noites grátis' },
    type: 'rate',
  },

  SPECIAL_OFFER: {
    description: { es: 'Oferta especial', pt: 'Oferta especial' },
    type: 'rate',
  },

  TRANSFER_INCLUDED: {
    description: {
      es: 'Esta tarifa incluye traslado del aeropuerto',
      pt: 'Esta tarifa inclui o traslado para o aeroporto.',
    },
    type: 'service',
  },

  TRASNFER_INCLUDED: {
    description: {
      es: 'Esta tarifa incluye traslado del aeropuerto',
      pt: 'Esta tarifa inclui o traslado para o aeroporto.',
    },
    type: 'service',
  },

  FREE_PARKING: {
    description: { es: '¡Estacionamiento gratuito!', pt: 'Estacionamento gratuito' },
    type: 'service',
  },

  FREE_WIFI: {
    description: { es: '¡Wifi gratis!', pt: 'Wi-fi grátis!' },
    type: 'service',
  },
};

export class HotelPromotion implements IHotelPromotion {
  public type: string;
  public description: string;

  constructor(public id: string) {
    const promotion = PROMOTION_DATA[this.id.toUpperCase()];
    this.type = (promotion && promotion.type) || null;
    this.id = (this.type && this.mappingIconName(this.id.toLowerCase())) || null;
    this.description = this.type
      ? window._app_context.country === 'bra'
        ? promotion.description.pt
        : promotion.description.es
      : null;
  }

  private mappingIconName(mappId: string) {
    switch (mappId) {
      case 'adults_only':
        this.id = 'adult';
        break;
      case 'free_parking':
        this.id = 'parking';
        break;
      case 'free_wifi':
        this.id = 'wifi';
        break;
      case 'transfer_included':
        this.id = 'transfer';
        break;
      case 'trasnfer_included':
        this.id = 'transfer';
        break;

      default:
        break;
    }
    return this.id;
  }
}
